<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">
                {{ isEdit ? "Edit" : "Add" }} Event
              </h3>
            </div>
            <v-stepper v-model="e1" light>
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1" editable
                  >Event Details</v-stepper-step
                >

                <v-divider></v-divider>

                <v-stepper-step v-if="!isEdit" :complete="e1 > 2" step="2"
                  >Event Image</v-stepper-step
                >
                 <v-stepper-step v-if="isEdit" :complete="e1 > 2" step="2" @click="update"
                  >Event Image</v-stepper-step
                >
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content class="v-form-body pa-0" step="1">
                  <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    enctype="multipart/form-data"
                    class="body-content event-form"
                  >
                    <v-row>
                      <v-col cols="12">
                        <label class="form-control-label">
                          Title
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="event.title"
                          solo
                          label="Enter Title"
                          auto-grow
                          :rules="[(v) => !!v || 'Title is required!', (v) => v && !!v.trim() || 'Field cannot be blank']"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="4">
                        <label class="form-control-label">
                          Start Date
                          <span class="red--text">*</span>
                        </label>
                        <v-menu
                          ref="startDate"
                          v-model="startDateModel"
                          :close-on-content-click="false"
                          :return-value.sync="event.startDate"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="event.startDate"
                              label="Start Date"
                              solo
                              scrollable
                              v-bind="attrs"
                              v-on="on"
                            >
                            </v-text-field>
                          </template>
                          <!-- :allowed-minutes="allowedStep" -->
                          <v-date-picker
                            v-if="startDateModel"
                            v-model="event.startDate"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="startDateModel = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.startDate.save(event.startDate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <!-- <v-datetime-picker
                          v-model="event.startDate"
                          :textFieldProps="datetimePickerField"
                          :date-picker-props="dateProps"
                          :time-picker-props="timeProps"
                          class="event-date"
                        >
                        <template slot="actions" slot-scope="{ parent }">
                          <v-btn color="#bdbdbd" text @click.native="parent.clearHandler">Cancel</v-btn>
                          <v-btn color="#344452" text @click="parent.okHandler">Done</v-btn>
                        </template>
                        </v-datetime-picker> -->
                        <!-- <v-row
                            justify="space-around"
                            align="center"
                          >
                            <v-col style="width: 350px; flex: 0 1 auto;">
                              <h2>Start:</h2>
                              <v-time-picker
                                v-model="start"
                                :max="end"
                              ></v-time-picker>
                            </v-col>
                            <v-col style="width: 350px; flex: 0 1 auto;">
                              <h2>End:</h2>
                              <v-time-picker
                                v-model="end"
                                :min="start"
                              ></v-time-picker>
                            </v-col>
                          </v-row> -->
                      </v-col>
                      <v-col cols="4">
                        <label class="form-control-label">
                          Start Time
                          <span class="red--text">*</span>
                        </label>
                        <v-menu
                          ref="startTime"
                          v-model="startTimeModel"
                          :close-on-content-click="false"
                          :return-value.sync="event.startTime"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="event.startTime"
                              label="Start Time"
                              solo
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            :max="event.endTime"
                            v-if="startTimeModel"
                            v-model="event.startTime"
                            format="ampm"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="startTimeModel = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.startTime.save(event.startTime)"
                            >
                              OK
                            </v-btn>
                          </v-time-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="4">
                        <label class="form-control-label">
                          End Time
                          <span class="red--text">*</span>
                        </label>
                        <v-menu
                          ref="endTime"
                          v-model="endTimeModel"
                          :close-on-content-click="false"
                          :return-value.sync="event.endTime"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="event.endTime"
                              label="End Time"
                              solo
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            :min="event.startTime"
                            v-if="endTimeModel"
                            v-model="event.endTime"
                            format="ampm"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="endTimeModel = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.endTime.save(event.endTime)"
                            >
                              OK
                            </v-btn>
                          </v-time-picker>
                        </v-menu>
                      </v-col>

                      <v-col cols="6">
                        <label class="form-control-label">
                          Location
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="event.location"
                          placeholder="Enter Location"
                          :rules="[(v) => !!v || 'Location is required!', (v) => v && !!v.trim() || 'Field cannot be blank']"
                          required
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <label class="form-control-label">
                          URL
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="event.url"
                          placeholder="Enter URL"
                          :rules="validateUrl"
                          required
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <label class="form-control-label">
                          Additional Notes
                        </label>
                        <v-text-field
                          v-model="event.notes"
                          placeholder="Enter Note"
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col class="text-right" cols="12">
                        <v-btn
                          color="#989898"
                          class="mr-4 white--text"
                          @click="cancel"
                          >Cancel</v-btn
                        >
                        <v-btn
                          v-if="!isEdit"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="create"
                          >Next</v-btn
                        >
                        <v-btn
                          v-if="isEdit"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="update"
                          >Update</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content class="v-form-body" step="2">
                  <v-row>
                    <v-col
                      :class="$vuetify.breakpoint.mdAndUp ? 'col-6' : 'col-12'"
                      class="pa-5"
                    >
                      <v-card>
                        <v-card-title>
                          <span class="Subtitle 1">Upload Image</span>
                        </v-card-title>
                        <v-card-text>
                          <vue-dropzone
                            class="vue-dropzone-box"
                            ref="myVueDropzone"
                            id="dropzone"
                            :destroyDropzone="false"
                            :options="dropzoneOptions"
                            @vdropzone-sending="beforecomplete"
                            @vdropzone-success="aftercomplete"
                            @vdropzone-mounted="uploadedImage"
                            @vdropzone-removed-file="removeFile"
                            :useCustomSlot="true"
                            :useCustomDropzoneOptions="true"
                          >
                            <div class="dropzone-custom-content">
                              <img src="@/assets/images/ImageUpload.svg" />
                              <h3 class="font-weight-light ma-0">
                                Drag and drop here to upload
                              </h3>
                              <h3 class="font-weight-light ma-0">Or</h3>
                              <h3 class="dropzone-custom-title">Browse</h3>
                            </div>
                          </vue-dropzone>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col class="text-right" cols="12">
                      <v-btn
                        color="#989898"
                        class="mr-4 white--text"
                        @click="back"
                        >Back</v-btn
                      >
                      <v-btn
                        :disabled="!valid"
                        :loading="loading"
                        color="#344452"
                        class="white--text"
                        @click="save"
                        >{{ isEdit ? "Update" : "Save" }}</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CommonSection from "@/components/CommonHeader";
import { eventService, MediaService } from "@/services";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Vue from "vue";
import DatetimePicker from "vuetify-datetime-picker";
Vue.use(DatetimePicker);
import moment from "moment";

export default {
  name: "AddEvents",
  components: {
    CommonSection,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      e1: 1,
      loading: false,
      valid: true,
      event: {
        title: null,
        startDate: null,
        startTime: null,
        endTime: null,
        //endDate: null,
        location: null,
        url: null,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        notes: null,
      },
      datepickerField: false,
      isEdit: false,
      validateUrl: [
        (value) => !!value || "URL is Required.",
        (v) => v && !!v.trim() || 'Field cannot be blank',
        (v) =>
          !v ||
          /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/.test(
            v
          ) ||
          "URL is not valid.",
      ],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_SERVERURL}media`,
        chunking: true,
        addRemoveLinks: true,
        thumbnailWidth: 400,
        autoProcessQueue: true,
        maxFilesize: 2,
        maxFiles: 1,
        dictFileTooBig:"File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        headers: {
          Authorization: `Bearer ${store.state.user.token}`,
        },
        init() {
          this.on("maxfilesexceeded", function(file) {
            this.removeAllFiles();
            this.addFile(file);
          });
          this.on("addedfile", file => {
            if (file.size > 1024 * 1024 * 2) {
              // not more than 2mb
              this.removeFile(file);
            }
          });
        },
        acceptedFiles: "image/*",
      },
      media: [],
      eventId: null,
      datetimePickerField: {
        solo: true,
        placeholder: "Select Date & Time",
        appendIcon: "event",
      },
      dateProps: {
        headerColor: "#344452",
      },
      // endDateProps:{
      //   headerColor: "#344452",
      //   min: new Date()
      // },
      timeProps: {
        headerColor: "#344452",
      },
      startDateModel: false,
      startTimeModel: false,
      endTimeModel: false,
    };
  },
  // watch:{
  //   'event.startDate':function(val){
  //     this.endDateProps.min = moment(val).format("YYYY-MM-DD")
  //   }
  // },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id !== "create") {
        this.isEdit = true;
        await this.getData();
        await this.uploadedImage();
      }
    },
    beforecomplete(file, xhr, formData) {
      formData.append("mediaType", "image");
      formData.append("moduleType", "event");
      formData.append("mediaSubType", "file");
      formData.append("moduleId", this.eventId);
    },
    aftercomplete(file, response) {
      this.$store.dispatch(
        "user/setSnack",
        "Event Image uploaded successfully!"
      );
      this.$store.dispatch("user/setType", "info");
      this.getData();
    },
    uploadedImage() {
      if (this.media && this.media.length > 0) {
        this.media.filter((media) => {
          if (media.mediaType == "image") {
            var file = {
              size: media.size,
              name: media.name,
              type: media.type,
            };
            this.$refs.myVueDropzone.manuallyAddFile(file, media.url);
          }
        });
      }
    },
    removeFile(file, error, xhr) {
      if (file.size > 1024 * 1024 * 2) {
        this.$store.dispatch(
          "user/setSnack",
          "Upto 2MB File size is allowed"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.deletePicture(file);
    },
    async deletePicture(file) {
      try {
        if (file) {
          let mediaId = this.media.filter((media) => {
            if (media.mediaType == "image" && media.name == file.name) {
              return media._id;
            }
          });
          if (mediaId.length > 0) {
            const response = await MediaService.deleteMedia({
              id: mediaId[0]._id,
              body: {
                moduleType: "event",
                moduleId: this.eventId,
              },
            });
            if (response) {
              this.$store.dispatch(
                "user/setSnack",
                "Event Image deleted successfully!"
              );
              this.$store.dispatch("user/setType", "info");
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getData() {
      let event;
      if (this.$route.params.id === "create") {
       event = await eventService.get(this.eventId);
      }
      else{
         event = await eventService.get(this.$route.params.id);
      } 
        this.event.title = event.data.data[0].title;
        this.event.startDate = moment(event.data.data[0].startDate).format("YYYY-MM-DD");
        this.event.startTime = event.data.data[0].startTime;
        this.event.endTime = event.data.data[0].endTime;
        this.event.location = event.data.data[0].location;
        this.event.url = event.data.data[0].url;
        this.event.timeZone = event.data.data[0].timeZone;
        this.event.notes = event.data.data[0].notes;
        this.media = event.data.data[0].media;
        this.isEdit = true;
    },
    cancel() {
      this.$router.push("/events");
    },
    back() {
      this.e1 = 1;
    },
    async create() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await eventService.create(this.event);
          if (response) {
            this.loading = false;
            this.e1 = 2;
            this.eventId = response.data.id;
            this.$store.dispatch("user/setSnack", "Event added successfully!");
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
        }
        this.loading = false;
      }
    },
    async update() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await eventService.update({
            id: this.$route.params.id,
            object: this.event,
          });
          this.loading = false;
          if (response) {
            this.eventId = response.data.id;
            this.$store.dispatch(
              "user/setSnack",
              "Event updated successfully!"
            );
            this.$store.dispatch("user/setType", "info");
            this.e1 = 2;
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          this.loading = false;
          this.$router.push("/events");
          this.$store.dispatch(
            "user/setSnack",
            `Event ${this.isEdit ? "updated" : "added"} successfully!`
          );
          this.$store.dispatch("user/setType", "info");
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scopped>
.main-content .navbar-top {
  display: none !important;
}

.body-content {
  padding: 40px !important;
}
.v-picker{
  .primary {
    background-color: #344452 !important;
    border-color: #344452 !important;
  }
  .accent {
    background-color: #344452 !important;
    border-color: #344452 !important;
  }
  .primary--text {
    color: #344452 !important;
  }
}

</style>